import { Template } from "./template.js";
import { Left_menu } from './left_menu/component.js'
import { Info_window } from './info_window/component.js'

const Page3_users = {
	name: 'Page3_users',
	components: {
		'left-menu': Left_menu,
		'info-window': Info_window
	},
	template: Template,
	data: function() {
		return {
			users: [],


			selectedUser: null
		}
	},

	created() {
		var cont = this;
		// Первый запуск 
		this.getUsers();

	},
	beforeDestroy() {
		// при выходе - убиваем таймер аякса
		//clearInterval(this.intervalID);
	},
	mounted() {

	},

	methods: {
		updateUser(user) {
			var cont = this;
			if (user.delete) {
				cont.users.find(function(el, index) {
					if (el.name == user.name) {
						//						delete cont.users[index];
						cont.$delete(cont.users, index);
						cont.selectedUser = cont.users.find(function() { return true });
						return true;
					}
				});

			} else {
				if (user.mode == 'edit') {

					this.selectedUser.name = user.name;
					this.selectedUser.email = user.email;
					this.selectedUser.group = user.group;
					this.selectedUser.phone = user.phone;
					this.selectedUser.notification1 = user.notification1;
					this.selectedUser.notification2 = user.notification2;
				} else {
					var newUser = {};
					newUser.name = user.name;
					newUser.email = user.email;
					newUser.group = user.group;
					newUser.phone = user.phone;
					newUser.notification1 = user.notification1;
					newUser.notification2 = user.notification2;
					this.users.push(newUser);
					this.selectedUser = newUser;

				}
			}
		},

		userClick(user) {
			var cont = this;

			this.selectedUser = user; // info_window увидит это, и отрисует график
		},
		getUsers() {
			//console.log('get tube data');
			var cont = this;
			//запускаем аякс из плагина
			this.$API('users', 'usersList', {},
				function(data) {
					cont.users = data;
					if (data[0]) cont.selectedUser = data[0];
				},
				function(errorText) { console.log(errorText) });

		}

	}


}

export { Page3_users }


// WEBPACK FOOTER //
// ./src/app/js/components/page3_users/component.js